module.exports = __webpack_public_path__ + "assets/img/juqu_content_img.11b4a7a5.png";